import { render, staticRenderFns } from "./AppDashboardPage.vue?vue&type=template&id=394a5a72"
import script from "./AppDashboardPage.vue?vue&type=script&lang=js"
export * from "./AppDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./AppDashboardPage.vue?vue&type=style&index=0&id=394a5a72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports